import React, {
  createContext,
  useEffect,
  useContext,
  useState,
  useCallback
} from "react";
import GlobalsContext from "../context/GlobalsContext";

const TimeTrackingContext = createContext(null);

export const useTimeTrackingContext = () => {
  return useContext(TimeTrackingContext);
};

const ALLOWED_USER_IDS = [
  1578,
  28856,
  29252,
  29349,
  28078,
  26266,
  27709,
  2098,
  26269,
  28152,
  29691,
  // 14500,
  26653,
  22324,
  28002,
  28759,
  29248,
  29342,
  29381,
  29406,
  23777,
  29938,
  29262
];

const DEFAULT_INACTIVITY_TIME = 5 * 60 * 1000; // 5 min

const inactivityTimeMap = {
  26653: 15 * 60 * 1000, // 15 min
  22324: 15 * 60 * 1000,
  26269: 20 * 60 * 1000, // 20 min
  2098: 7 * 24 * 60 * 60 * 1000,
  28152: 12 * 60 * 1000, // 12 min
  28002: 7 * 60 * 1000, // 7 min
  28759: 7 * 60 * 1000,
  29248: 7 * 60 * 1000,
  29342: 7 * 60 * 1000,
  29381: 7 * 60 * 1000,
  29406: 7 * 60 * 1000,
  23777: 7 * 60 * 1000,
  29938: 7 * 60 * 1000,
  29262: 7 * 60 * 1000
};

export const TimeTrackingProvider = ({ children }) => {
  const globals = useContext(GlobalsContext);
  const [sdk, setSdk] = useState(null);
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!ALLOWED_USER_IDS.includes(globals.user.id)) {
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://time.24smi.info/static/sdk.min.js";
    script.addEventListener("load", () => {
      const TimeTrackingSDK = window.TimeTrackingSDK.TimeTrackingSDK;
      const sdk = new TimeTrackingSDK({
        baseUrl: "https://time.24smi.info",
        inactivityTime:
          inactivityTimeMap[globals.user.id] ?? DEFAULT_INACTIVITY_TIME,
        // 1 минута
        pingInterval: 60 * 1000,
        // 30 секунд
        healthcheckInterval: 30 * 1000
      });
      const listeners = [
        sdk.on("stateChanges", state => {
          setState(state);
        }),
        sdk.on("error", console.error)
      ];
      sdk.setUser({
        id: `${globals.user.id}`,
        email: `${globals.user.name}@content.com`
      });
      setSdk(sdk);
    });
    document.body.append(script);

    return () => {
      script.remove();
      for (const off of listeners) {
        off();
      }
    };
  }, []);

  const startSession = useCallback(() => {
    if (!sdk) {
      return;
    }

    sdk.startSession();
  }, [sdk]);

  const stopSession = useCallback(async () => {
    if (!sdk) {
      return;
    }

    await sdk.stopSession();
  }, [sdk]);

  return (
    <TimeTrackingContext.Provider value={{ state, startSession, stopSession }}>
      {children}
    </TimeTrackingContext.Provider>
  );
};
